module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUdwTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBHYtUAAAASdFJOUwCFHCpto5gMBEcje2cSr7s/VqMkPXEAAABRSURBVAjXPYpJAsAgCAOjAu5V///ZFtHmAAwZQONLgiVVJhIXN8jUGVipZROKA/JzdYXR8SfdAvT5dO44GlCDQRf9sN/FY0tcnpXL0f1a230BftUBvoLidIMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontierPage/change.png
// module id = /oMs
// module chunks = 0